import React, { useState } from 'react'
import './ai-feature-content.scss'
import { recordingEntitties } from '../../constant';
import OptionLayout from '../OptionLayout';
import { useTranslation } from 'react-i18next';
import sessionPage from '../../assets/images/session-page.png';

const AIFeaturesContent = () => {
	const [entities, setEntities] = useState(recordingEntitties);
	const [selectedEntities, setSelectedEntities] = useState([]);
	const { t } = useTranslation();

	const handleSelection = (defaultSelected, selectedValue) => {

		let settings = [...entities];

		settings.forEach((s) => {
			s?.entities?.forEach((record) => {
				if (defaultSelected && defaultSelected.includes(record.id)) {
					record.isSelected = selectedValue;
				}

				if (record.counter_dependency && record.counter_dependency.length > 0) {
					record.counter_dependency.forEach((counterDepId) => {
						const counterDependentRecord = settings
							.flatMap((s) => s?.entities || [])
							.find((r) => r.id === counterDepId);

						if (counterDependentRecord) {
							if (!defaultSelected.includes(counterDependentRecord.id)) {
								counterDependentRecord.isSelected = false;
							}
						}
					});
				}
			});
		});

		setEntities(settings);

		setSelectedEntities(getSelectedEntries(settings));
	};

	const getSelectedEntries = (settings) => {
		let selectedEntries = [];

		settings?.forEach((s) => {
			s?.entities?.forEach((record) => {
				if (record.isSelected) {
					selectedEntries.push(record);
				}
			});
		});

		return selectedEntries;
	};

	console.log('entities', entities);

	return (
		<div className='features-containers'>
			<h1>{t('artificial_intelligence_overview')}</h1>
			<p>{t('artificial_intelligence_overview_desc')}</p>

			<div className={'instructor-profile-container'}>
				{
					<div
						className={'instructor-option-container'}
					>
						<div
							className={'option-container-header'}
						>
						</div>
						{
							<div className={'ml-3'}>
								<div className={'layout-container'}>
									{
										entities[3]?.entities?.map((value, index) => (
											<OptionLayout
												key={index}
												title={t(value.key)}
												imageSource={value.image}
												record={value}
												handleSelection={handleSelection}
											/>
										))
									}
								</div>
							</div>
						}
					</div>
				}
			</div>

			<h2>{t('multiple_people')}</h2>
			<p>{t('multiple_people_desc')}</p>

			<h2>{t('person_missing')}</h2>
			<p>{t('person_missing_desc')}</p>

			<h2>{t('object_detection')}</h2>
			<p>{t('object_detection_desc')}</p>

			<h2>{t('speech_detection')}</h2>
			<p>{t('speech_detection_desc')}</p>
		</div>
	)
}

export default AIFeaturesContent